import React from "react";
import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import parakeetLogo from "../assets/parakeet_logo_1.png"; // Ensure this path is correct
import PropTypes from "prop-types";

const Header = ({ isLoggedIn, onLogout }) => {
  const location = useLocation();

  // Helper function to check if a link is active
  const isActive = (path) => location.pathname === path;

  return (
    <AppBar
      position="static"
      sx={{
        marginBottom: 2,
        backgroundColor: "#1f1f1f",
        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
        transition: "background-color 0.3s ease-in-out",
        "&:hover": {
          backgroundColor: "#242424",
        },
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          paddingX: 3,
        }}
      >
        {/* Logo and Brand Name - Clickable */}
        <Link
          to="/"
          style={{
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
            color: "inherit",
          }}
        >
          <img
            src={parakeetLogo}
            alt="Datakeet Logo"
            style={{
              width: "40px",
              marginRight: "12px",
              borderRadius: "50%",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
              cursor: "pointer",
            }}
          />
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              color: "#ffffff",
              transition: "transform 0.3s ease-in-out",
              "&:hover": {
                transform: "scale(1.05)",
              },
            }}
          >
            Datakeet
          </Typography>
        </Link>

        {/* Navigation Links */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {[
            { label: "Dashboard", path: "/dashboard" },
            { label: "About", path: "/about" },
            { label: "Pricing", path: "/pricing" },
          ].map((item) => (
            <Button
              key={item.label}
              color="inherit"
              component={Link}
              to={item.path}
              sx={{
                marginRight: 2,
                color: isActive(item.path) ? "#00acc1" : "#ffffff",
                fontWeight: isActive(item.path) ? "bold" : "normal",
                transition: "color 0.3s ease-in-out",
                "&:hover": { color: "#00acc1" },
              }}
              aria-label={item.label}
            >
              {item.label}
            </Button>
          ))}

          {/* Auth Buttons */}
          {isLoggedIn ? (
            <Button
              color="inherit"
              onClick={onLogout}
              sx={{
                color: "#ffffff",
                transition: "color 0.3s ease-in-out",
                "&:hover": { color: "#00acc1" },
              }}
              aria-label="Logout"
            >
              Logout
            </Button>
          ) : (
            <Button
              color="inherit"
              component={Link}
              to="/login"
              sx={{
                color: "#ffffff",
                transition: "color 0.3s ease-in-out",
                "&:hover": { color: "#00acc1" },
              }}
              aria-label="Login"
            >
              Login
            </Button>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

// Prop validation
Header.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  onLogout: PropTypes.func.isRequired,
};

export default Header;
